/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormIntAlternateText
 */
export interface FormIntAlternateText {
    /**
     * 
     * @type {string}
     * @memberof FormIntAlternateText
     */
    unknown?: string;
    /**
     * 
     * @type {string}
     * @memberof FormIntAlternateText
     */
    englishUS?: string;
    /**
     * 
     * @type {string}
     * @memberof FormIntAlternateText
     */
    spanish?: string;
}

export function FormIntAlternateTextFromJSON(json: any): FormIntAlternateText {
    return FormIntAlternateTextFromJSONTyped(json, false);
}

export function FormIntAlternateTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormIntAlternateText {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unknown': !exists(json, 'Unknown') ? undefined : json['Unknown'],
        'englishUS': !exists(json, 'EnglishUS') ? undefined : json['EnglishUS'],
        'spanish': !exists(json, 'Spanish') ? undefined : json['Spanish'],
    };
}

export function FormIntAlternateTextToJSON(value?: FormIntAlternateText | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Unknown': value.unknown,
        'EnglishUS': value.englishUS,
        'Spanish': value.spanish,
    };
}


